import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CartPageComponent } from './cart-page/cart-page.component';
import { BillingPageComponent } from './billing-page/billing-page.component';
import { ConfirmationPageComponent } from './confirmation-page/confirmation-page.component';
import { AutoRenewalTermsPageComponent } from './auto-renewal-terms-page/auto-renewal-terms-page.component';
import { TaxIdentityShieldTermsPageComponent } from './tax-identity-shield-terms-page/tax-identity-shield-terms-page.component';
import { TermsPageComponent } from './terms-page/terms-page.component';

const routes: Routes = [
  { path: 'cart', component: CartPageComponent },
  { path: 'billing', component: BillingPageComponent },
  { path: 'confirmation', component: ConfirmationPageComponent},
  { path: 'autorenewal', component: AutoRenewalTermsPageComponent },
  { path: 'taxidentityshield', component: TaxIdentityShieldTermsPageComponent },
  { path: 'terms', component: TermsPageComponent,
    children: [
        { path: 'autorenewal', component: AutoRenewalTermsPageComponent },
        { path: 'taxidentityshield', component: TaxIdentityShieldTermsPageComponent }
    ] 
  },
  { path: '',   redirectTo: '/cart', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
